import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const prefabHomeFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Big Home",
          tagId: 2901,
        },
        {
          id: 2,
          label: "Tiny Home",
          tagId: 2902,
        },
        {
          id: 3,
          label: "Guesthouse",
          tagId: 2903,
        },
        {
          id: 4,
          label: "Office / Studio",
          tagId: 2904,
        },
        {
          id: 5,
          label: "Mobile on Wheels",
          tagId: 2905,
        },
        {
          id: 6,
          label: "Cabin / Bunkie",
          tagId: 2906,
        },
        {
          id: 7,
          label: "A-Frame",
          tagId: 2907,
        },
        {
          id: 8,
          label: "Container",
          tagId: 2908,
        },
        {
          id: 9,
          label: "Tent",
          tagId: 2909,
        },
        {
          id: 10,
          label: "Yurt",
          tagId: 2910,
        },
        {
          id: 11,
          label: "Dome",
          tagId: 2911,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "XS - 0-200 sqft",
          value: { minValue: 0, maxValue: 200 },
        },
        {
          id: 2,
          label: "S - 200-500 sqft",
          value: { minValue: 200, maxValue: 500 },
        },
        {
          id: 3,
          label: "M - 500-1k sqft",
          value: { minValue: 500, maxValue: 1000 },
        },
        {
          id: 4,
          label: "L - 1-2k sqft",
          value: { minValue: 1000, maxValue: 2000 },
        },
        {
          id: 5,
          label: "XL 2-5k sqft",
          value: { minValue: 2000, maxValue: 5000 },
        },
        {
          id: 6,
          label: "XXL - +5k sqft",
          value: { minValue: 5000 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PRICE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "$0 - $10k",
          value: { minValue: 0, maxValue: 10000 },
        },
        {
          id: 2,
          label: "$10k - $20k",
          value: { minValue: 10000, maxValue: 20000 },
        },
        {
          id: 3,
          label: "$20k - $50k",
          value: { minValue: 20000, maxValue: 50000 },
        },
        {
          id: 4,
          label: "$50k - $100k",
          value: { minValue: 50000, maxValue: 100000 },
        },
        {
          id: 5,
          label: "$100k - $200k",
          value: { minValue: 100000, maxValue: 200000 },
        },
        {
          id: 6,
          label: "$200k - $500k",
          value: { minValue: 200000, maxValue: 500000 },
        },
        {
          id: 7,
          label: "$500k - $1m",
          value: { minValue: 500000, maxValue: 1000000 },
        },
        {
          id: 8,
          label: "+$1m",
          value: { minValue: 1000000 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Bedrooms",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Studio",
          tagId: 3201,
        },
        {
          id: 2,
          label: "0",
          tagId: 3202,
        },
        {
          id: 3,
          label: "1",
          tagId: 3203,
        },
        {
          id: 4,
          label: "2",
          tagId: 3204,
        },
        {
          id: 5,
          label: "3",
          tagId: 3205,
        },
        {
          id: 6,
          label: "+4",
          tagId: 3206,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Bathrooms",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "0",
          value: { minValue: 0, maxValue: 0 },
        },
        {
          id: 2,
          label: "1",
          value: { minValue: 1, maxValue: 1 },
        },
        {
          id: 3,
          label: "2",
          value: { minValue: 2, maxValue: 2 },
        },
        {
          id: 4,
          label: "3",
          value: { minValue: 3, maxValue: 3 },
        },
        {
          id: 5,
          label: "+4",
          value: { minValue: 4 },
        },
      ],
      selectedList: [],
    },
    // {
    //   icon: Images.iconTagCountry,
    //   width: 16,
    //   height: 19.5,
    //   title: "Country",
    //   isHide: false,
    //   isSearchable: true,
    //   isCountry: true,
    //   detailList: [
    //     // from api country
    //   ],
    //   selectedList: [],
    // },
    {
      id: Constants.tagCategory.TAG_CATEGORY_CAPACITY,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Capacity",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "1 People",
          value: { minValue: 1, maxValue: 1 },
        },
        {
          id: 2,
          label: "2 People",
          value: { minValue: 2, maxValue: 2 },
        },
        {
          id: 3,
          label: "3 People",
          value: { minValue: 3, maxValue: 3 },
        },
        {
          id: 4,
          label: "4 People",
          value: { minValue: 4, maxValue: 4 },
        },
        {
          id: 5,
          label: "5 People",
          value: { minValue: 5, maxValue: 5 },
        },
        {
          id: 6,
          label: "6 People",
          value: { minValue: 6, maxValue: 6 },
        },
        {
          id: 7,
          label: "7 People",
          value: { minValue: 7, maxValue: 7 },
        },
        {
          id: 8,
          label: "+8 People",
          value: { minValue: 8 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Other Rooms",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "No Kitchen",
          tagId: 3701,
        },
        {
          id: 2,
          label: "Kitchenette",
          tagId: 3702,
        },
        {
          id: 3,
          label: "Full Kitchen",
          tagId: 3703,
        },
        {
          id: null,
          label: null,
          isSeparator: true,
        },
        {
          id: 4,
          label: "0 Loft",
          tagId: 3801,
        },
        {
          id: 5,
          label: "1 Loft",
          tagId: 3802,
        },
        {
          id: 6,
          label: "2 Loft",
          tagId: 3803,
        },
        {
          id: 7,
          label: "+3 Loft",
          tagId: 3804,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Assembling",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Pre-Assembled - Mobile Home",
          tagId: 3901,
        },
        {
          id: 2,
          label: "Pre-Assembled",
          tagId: 3902,
        },
        {
          id: 3,
          label: "Assembled On-Site",
          tagId: 3903,
        },
      ],
      selectedList: [],
    },
    // {
    //   id: Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_TYPE,
    //   icon: Images.iconTagStatus,
    //   width: 20,
    //   height: 20,
    //   title: "Dimensions",
    //   isHide: false,
    //   isDimension: true,
    //   detailList: [
    //     {
    //       id: 1,
    //       label: "ft",
    //       tagId: 3401,
    //     },
    //     {
    //       id: 2,
    //       label: "m",
    //       tagId: 3402,
    //     },
    //   ],
    //   selectedList: [],
    // },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
